import { useStore } from 'vuex';

import authApi from '@/modules/auth/api/authApi';
import utils from '@/utils/utils';

import { useLoading } from 'vue-loading-overlay';

const useInventarios = () => {
    const store = useStore();
    const $loading = useLoading();

    const obtenerKardexProductos = async (page = 1, limit = 25, search = '') => {
        const respuesta = {
            ok: false,
            data: undefined as any,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.get(
                `/inventario/obtener-kardex-productos/${ store.getters['auth/getIdSucursal'] }`,
                {
                    params: { page, limit, search },
                    headers: {
                        'Content-type' : 'application/json',
                        'Authorization': 'Bearer ' + store.getters['auth/getToken'],
                    }
                }
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok   = true;
                respuesta.data = data.datos;
            } else {
                utils.mostrarMensaje({
                    descripcion: data.mensaje.descripcion,
                    tipoMensaje: data.mensaje.tipoMensaje
                });
            }
        } catch (error) {
            loader.hide();
            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    };

    const obtenerKardexIndividual = async (idProductoStock: number, page = 1, limit = 50, anio = 0, mes = 0) => {
        const respuesta = {
            ok: false,
            data: undefined as any,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.get(
                `/inventario/kardex-individual/${ store.getters['auth/getIdSucursal'] }/${ idProductoStock }`,
                {
                    params: { page, limit, anio, mes },
                    headers: {
                        'Content-type' : 'application/json',
                        'Authorization': 'Bearer ' + store.getters['auth/getToken'],
                    }
                }
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok   = true;
                respuesta.data = data.datos;
            } else {
                utils.mostrarMensaje({
                    descripcion: data.mensaje.descripcion,
                    tipoMensaje: data.mensaje.tipoMensaje
                });
            }
        } catch (error) {
            loader.hide();
            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    };

    const obtenerKardexDia = async (fecha: string, search = '') => {
        const respuesta = {
            ok: false,
            data: undefined as any,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.get(
                `/inventario/obtener-kardex-dia/${ store.getters['auth/getIdSucursal'] }`,
                {
                    params: { fecha, search },
                    headers: {
                        'Content-type' : 'application/json',
                        'Authorization': 'Bearer ' + store.getters['auth/getToken'],
                    }
                }
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok   = true;
                respuesta.data = data.datos;
            } else {
                utils.mostrarMensaje({
                    descripcion: data.mensaje.descripcion,
                    tipoMensaje: data.mensaje.tipoMensaje
                });
            }
        } catch (error) {
            loader.hide();
            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    };

    return {
        obtenerKardexProductos,
        obtenerKardexIndividual,
        obtenerKardexDia,
    };
};

export default useInventarios;
